import React from 'react'
import Layout from 'marketing-site/src/components/common/Layout'
import { ILayout, IPageBehavior } from 'marketing-site/@types/generated/contentful'

interface IProps {
  layout?: ILayout
  pageBehaviors?: IPageBehavior[]
}

export const ContentfulLayout: React.FC<IProps> = function ({ children, pageBehaviors, layout }) {
  if (!layout || !('sys' in layout)) {
    return <>{children}</>
  }

  const layoutClasses = pageBehaviors?.map((behavior) => behavior.fields.identifier).join(' ') || ''

  return (
    <Layout layout={layout} classes={layoutClasses}>
      {children}
    </Layout>
  )
}
